/* eslint-disable */
import React from "react";
import PaperComponent from "../../components/PaperComponent/PaperComponent";
import SystemUsers from "../../components/SystemUsers/SystemUsers";

export default function SystemUsersPage() {
  return <PaperComponent children={<SystemUsers />} />;
}
